(() => {
  const script = document.querySelector('script[src*="yotpo-referral-auth.js"]');
  const loginUrl = script?.dataset.loginUrl;
  const registerUrl = script?.dataset.registerUrl;

  if (!loginUrl || !registerUrl) return;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button[data-cy="login-login-button"], button[data-cy="login-register-button"]');

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.href = button.dataset.cy === 'login-register-button' ? registerUrl : loginUrl;
    },
    true,
  );
})();